export function guid() {
	function s4() {
		return Math.floor((1 + Math.random()) * 0x10000)
			.toString(16)
			.substring(1);
	}
	return s4() + s4() + "-" + s4() + "-" + s4() + "-" +
		s4() + "-" + s4() + s4() + s4();
}

const DATE_ACCESSOR = d => d.date;

export function getStartAndEndDateForPeriod(period, dateRange) {
	if (period === "all") {
		return {
			start: DATE_ACCESSOR(dateRange.fullData.start),
			end: DATE_ACCESSOR(dateRange.fullData.end),
		};
	}

	var l = period.length;
	var multiplier = Number(period.substring(0, l - 1));
	var type = period.substring(l - 1);

	var { fullData, viewData, xAccessor } = dateRange;
	var yearDiff = 0, monthDiff = 0, dayDiff = 0;
	switch (type) {
		case "d": {
			dayDiff = multiplier;
			break;
		}
		case "m": {
			monthDiff = multiplier;
			break;
		}
		case "y": {
			yearDiff = multiplier;
			break;
		}
	}
	var start = new Date(DATE_ACCESSOR(viewData.end));
	var end = new Date(DATE_ACCESSOR(viewData.end));
	start.setDate(start.getDate() - dayDiff);
	start.setMonth(start.getMonth() - monthDiff);
	start.setFullYear(start.getFullYear() - yearDiff);
	if (start < DATE_ACCESSOR(fullData.start)) {
		start = new Date(DATE_ACCESSOR(fullData.start));
		end = new Date(DATE_ACCESSOR(fullData.start));

		end.setDate(start.getDate() + dayDiff);
		end.setMonth(start.getMonth() + monthDiff);
		end.setFullYear(start.getFullYear() + yearDiff);
	}
	if (end > DATE_ACCESSOR(fullData.end)) {
		end = new Date(DATE_ACCESSOR(fullData.end));
	}
	// console.log(period);
	// console.log(start, end);
	return { start, end };
}


/** WEBPACK FOOTER **
 ** ./src/scripts/utils/index.js
 **/